<template>
    <div class="" v-if="show_activity">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item" aria-current="page">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0)">Reports</a>
                    </li>
                    <li class="breadcrumb-item" aria-current="page">
                        <a href="javascript:void(0)">Asset Reports</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">View Activity</li>
                </ol>
                <h4 class="main-title mb-0">Activity</h4>
            </div>
            <router-link to="/asset_reports" type="submit" class="btn btn-primary"><i class="ri-arrow-left-line"></i> BACK</router-link>
        </div>
        <div class="row">
            <div class="col-12">
                <form @submit.prevent="submitForm">
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                            <h6 class="card-title">Activity</h6>
                        </div>
                        <div class="card-body">
                            <div class="row g-2">
                                <div class="col-md-4">
                                    <label class="form-label">Activity Date & Time</label><span class="text-danger"> *</span>
                                    <input disabled type="datetime-local" class="form-control" placeholder="Enter Activity Date" :class="{'is-invalid': errors.activity_date}" ref="activity_date" :value="convertDateFormat(activity.activity_date)" v-model="activity.activity_date"/>
                                    <span v-if="errors.activity_date" class="invalid-feedback">{{ errors.activity_date[0] }}</span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Activity Status</label><span class="text-danger"> *</span>
                                    <select disabled class="form-control" v-model="activity.activity_status" :class="{'is-invalid': errors.activity_status}">
                                        <option value="">Select Status</option>
                                        <option value="Added">Added</option>
                                        <option value="Removed">Removed</option>
                                        <option value="Scraped">Scraped</option>
                                    </select>
                                    <span v-if="errors.activity_status" class="invalid-feedback">{{ errors.activity_status[0] }}</span>
                                </div>

                                <div class="col-md-4">
                                    <label class="form-label">Asset</label><span class="text-danger"> *</span>
                                    <input type="text" disabled class="form-control" :value="activity?.asset?.asset_name" />
                                    <span v-if="errors.asset_id" class="invalid-feedback">{{ errors.asset_id[0] }}</span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Equipment</label><span class="text-danger"> *</span>
                                    <input type="text" disabled class="form-control" :value="activity.equipment?.equipment_code + ' :: ' + activity.equipment?.equipment_name" />
                                    <span v-if="errors.equipment_id" class="invalid-feedback">{{ errors.equipment_id[0] }}</span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Reason</label><span class="text-danger" v-if="activity.activity_status == 'Removed' || activity.activity_status == 'Scraped'"> *</span>
                                    <input type="text" disabled class="form-control" :value="activity.reason?.reason_code + ' :: ' + activity.reason?.reason_name" />
                                    <span v-if="errors.reason_id" class="invalid-feedback">{{ errors.reason_id[0] }}</span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Cost</label>
                                    <input disabled type="number" placeholder="Enter Cost" class="form-control" :class="{'is-invalid':errors.cost}" v-model="activity.cost" />
                                    <span v-if="errors.cost" class="invalid-feedback">{{ errors.cost[0] }}</span>
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label">Note</label>
                                    <textarea disabled type="text" placeholder="Enter Note" class="form-control" :class="{'is-invalid': errors.note}" v-model="activity.note"></textarea>
                                    <span v-if="errors.note" class="invalid-feedback">{{ errors.note[0] }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <!-- service -->
    <div class="" v-if="show_service">
        <div class="">
            <div class="d-sm-flex align-items-center justify-content-between mb-2">
                <div>
                    <ol class="breadcrumb fs-sm mb-1">
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link to="/dashboard">Dashboard</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <a href="javascript:void(0)">Reports</a>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <a href="javascript:void(0)">Asset Reports</a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">View User Service</li>
                    </ol>
                    <h4 class="main-title mb-0">User Service</h4>
                </div>
                <router-link to="/asset_reports" type="submit" class="btn btn-primary"><i class="ri-arrow-left-line"></i> BACK</router-link>
            </div>
            <div class="row">
                <div class="col-12">
                    <form @submit.prevent="submitForm">
                        <div class="card card-one">
                            <div class="card-header d-flex justify-content-between">
                                <h6 class="card-title">User Service</h6>
                            </div>
                            <div class="card-body">
                                <div class="row g-2 mb-5">
                                    <div class="col-md-4">
                                        <label class="form-label">Service Date</label><span class="text-danger"> *</span>
                                        <input disabled type="datetime-local" class="form-control" placeholder="Enter Service Date" :class="{'is-invalid': errors.service_date}" :value="convertDateFormat(user_service.service_date)" v-model="user_service.service_date" ref="service_date"/>
                                        <span v-if="errors.service_date" class="invalid-feedback">{{ errors.service_date[0] }}</span>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label">Asset</label><span class="text-danger"> *</span>
                                        <input type="text" disabled class="form-control" :value="user_service.asset?.asset_name" />
                                        <span v-if="errors.asset_id" class="invalid-feedback">{{ errors.asset_id[0] }}</span>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label">Service</label><span class="text-danger"> *</span>
                                        <input type="text" disabled class="form-control" :value="user_service.service?.service_code + ' :: ' + user_service.service?.service_name" />
                                        <span v-if="errors.service_id" class="invalid-feedback">{{ errors.service_id[0] }}</span>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Next Service Date</label><span class="text-danger"> *</span>
                                        <input disabled type="datetime-local" class="form-control" placeholder="Enter Next Service Date" :class="{'is-invalid': errors.next_service_date}" :value="convertDateFormat(user_service.next_service_date)" v-model="user_service.next_service_date"/>
                                        <span v-if="errors.next_service_date" class="invalid-feedback">{{ errors.next_service_date[0] }}</span>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Service Cost</label>
                                        <input disabled type="number" placeholder="Enter Service Cost" min="0" oninput="validity.valid||(value='');" class="form-control" :class="{'is-invalid':errors.service_cost}" v-model="user_service.service_cost" />
                                        <span v-if="errors.service_cost" class="invalid-feedback">{{ errors.service_cost[0] }}</span>
                                    </div>
                                    <div class="col-md-12">
                                        <label class="form-label">Note</label>
                                        <textarea disabled type="text" placeholder="Enter Note" class="form-control" :class="{'is-invalid': errors.note}" v-model="user_service.note"></textarea>
                                        <span v-if="errors.note" class="invalid-feedback">{{ errors.note[0] }}</span>
                                    </div>
                                </div>
                                <div class="row g-2">
                                    <div class="table-responsive table-responsive-sm">
                                        <table class="table table-sm text-nowrap table-bordered mb-0">
                                            <thead>
                                                <tr style="background-color: #9b9b9b; color: white;">
                                                    <th>Spare</th>
                                                    <th>Spare Cost</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="spare, index in user_service.user_spares" :key="index">
                                                    <td>{{ spare?.spare?.spare_name }}</td>
                                                    <td>{{ spare?.spare_cost }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!-- check -->
    <div class="" v-if="show_check">
        <div class="">
            <div class="d-sm-flex align-items-center justify-content-between mb-2">
                <div>
                    <ol class="breadcrumb fs-sm mb-1">
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link to="/dashboard">Dashboard</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <a href="javascript:void(0)">Reports</a>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <a href="javascript:void(0)">Asset Reports</a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">View User Check</li>
                    </ol>
                    <h4 class="main-title mb-0">View User Check</h4>
                </div>
                <router-link to="/asset_reports" type="submit" class="btn btn-primary"><i class="ri-arrow-left-line"></i> BACK</router-link>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="card card-one mb-3">
                        <div class="card-header">
                            <h5 class="card-title">User Check</h5>
                            <br />
                        </div>
                        <div class="card-body p-0">
                            <div class="setting-item">
                                <div class="row g-2 mb-4">
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">Reference Number</label>
                                        <input type="text" disabled class="form-control" :value="user_check.reference_no" />
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">Asset Code</label>
                                        <input type="text" disabled class="form-control" :value="user_check?.asset?.asset_code" />
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">Reference Date</label>
                                        <input type="datetime-local" disabled class="form-control" :value="convertDateFormat(user_check.reference_date)" />
                                    </div>
                                    <div class="col-md-12 mb-3">
                                        <label class="form-label">Note</label>
                                        <textarea disabled class="form-control" rows="3" :value="user_check.note || ''"></textarea>
                                    </div>
                                    <div class="col-md-12 mt-1">
                                        <h6 class="mb-2">Asset Checks :</h6>
                                        <div class="table-responsive table-responsive-sm">
                                            <table class="table table-responsive table-sm text-nowrap table-bordered mb-0">
                                                <thead>
                                                    <tr>
                                                        <th class="text-center">#</th>
                                                        <th class="text-left">Field name</th>
                                                        <th>Field Type</th>
                                                        <th>Default Value</th>
                                                        <th>Is Required</th>
                                                        <th>Field Values</th>
                                                        <th>LCL</th>
                                                        <th>UCL</th>
                                                        <th>Value</th>
                                                        <th>Check Remark</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-for="(check, key) in user_check.asset_checks" :key="key">
                                                        <tr>
                                                            <td class="text-center">{{ key + 1 }}</td>
                                                            <td>{{ check.field_name }}</td>
                                                            <td>{{ check.field_type }}</td>
                                                            <td>{{ check.default_value }}</td>
                                                            <td>{{ check.is_required == 1 ? 'Yes' : 'No' }}</td>
                                                            <td>{{ check.field_values }}</td>
                                                            <td>{{ check.lcl }}</td>
                                                            <td>{{ check.ucl }}</td>
                                                            <td>{{ check.value }}</td>
                                                            <td>{{ check.check_remark || '' }}</td>
                                                        </tr>

                                                        <tr v-if="check.check_attachments && check.check_attachments.some(a => a.type === 'image')">
                                                            <td colspan="10">
                                                                <div class="d-flex flex-wrap gap-3">
                                                                    <div
                                                                        v-for="(img, index) in check.check_attachments.filter(a => a.type === 'image')"
                                                                        :key="'img-' + key + '-' + index"
                                                                        style="width: 120px;"
                                                                    >
                                                                        <a :href="$store.state.apiUrl + 'downloadCheckAttachment?file_name=' + img.file_name" target="_blank">
                                                                            <img
                                                                                :src="img.attachments"
                                                                                class="img-fluid"
                                                                                alt="Image"
                                                                                style="width: 120px; height: 120px; object-fit: cover; border: 1px solid #ddd;"
                                                                            />
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr v-if="check.check_attachments && check.check_attachments.some(a => a.type === 'audio')">
                                                            <td colspan="10">
                                                                <div class="d-flex flex-wrap gap-3">
                                                                    <div
                                                                        v-for="(audio, index) in check.check_attachments.filter(a => a.type === 'audio')"
                                                                        :key="'audio-' + key + '-' + index"
                                                                        style="width: 200px;"
                                                                    >
                                                                        <a :href="$store.state.apiUrl + 'downloadCheckAttachment?file_name=' + audio.file_name" target="_blank">
                                                                            <div
                                                                                style="padding: 5px; background-color: #f4f4f4; border: 1px solid #ddd;"
                                                                            >
                                                                                <audio :src="audio.attachments" controls style="width: 100%;"></audio>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr v-if="check.check_attachments && check.check_attachments.some(a => a.type === 'video')">
                                                            <td colspan="10">
                                                                <div class="d-flex flex-wrap gap-3">
                                                                    <div
                                                                        v-for="(video, index) in check.check_attachments.filter(a => a.type === 'video')"
                                                                        :key="'video-' + key + '-' + index"
                                                                        style="width: 200px;"
                                                                    >
                                                                        <a :href="$store.state.apiUrl + 'downloadCheckAttachment?file_name=' + video.file_name" target="_blank">
                                                                            <div
                                                                                style="padding: 5px; background-color: #f4f4f4; border: 1px solid #ddd;"
                                                                            >
                                                                                <video :src="video.attachments" controls style="width: 100%; height: 150px; object-fit: cover;"></video>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="row g-2">
                                    <h6>Attachments :</h6>
                                    <div class="col-2 mb-2 imageContainer" v-for="img, key in user_check.user_attachments" :key="key">
                                        <a :href="$store.state.apiUrl+'downloadCheckAttachment?file_name='+img.file_name">
                                            <img :src="img.attachments" class="img-fluid1" alt="" :href="img.attachments" style="width: 120px; height: 120px;" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Search from "@/components/Search.vue";
    import moment from "moment";
    export default {
        components: { Search },
        data() {
            return {
                activity: {},
                user_service: {},
                user_check: {},
                errors: [],
                show_activity: false,
                show_service: false,
                show_check: false,
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (to.params.type == "activity") {
                    vm.show_activity = true;
                    let uri = { uri: "getUserActivity", data: { user_activity_id: to.params.id } };
                    vm.$store
                        .dispatch("post", uri)
                        .then(function (response) {
                            vm.activity = response.data.data;
                        })
                        .catch(function (error) {
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
                if (to.params.type == "service") {
                    vm.show_service = true;
                    let uri = { uri: "getUserService", data: { user_service_id: to.params.id } };
                    vm.$store
                        .dispatch("post", uri)
                        .then(function (response) {
                            vm.user_service = response.data.data;
                        })
                        .catch(function (error) {
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
                if (to.params.type == "user_check") {
                    vm.show_check = true;
                    let uri = { uri: "getUserCheck", data: { user_check_id: to.params.id } };
                    vm.$store
                        .dispatch("post", uri)
                        .then(function (response) {
                            vm.user_check = response.data.data;
                        })
                        .catch(function (error) {
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
            });
        },
        methods: {
            convertDateFormat(date) {
                let vm = this;
                return moment(date).format("YYYY-MM-DDTHH:mm");
            },
        },
    };
</script>
<style scoped>
    .setting-item .table th:not(:first-child),
    .setting-item .table td:not(:first-child) {
        text-align: left !important;
        padding: 3px;
    }
</style>